<script>
import StoreSearchResults from '@phoenix/mixins/components/store/StoreSearchResults';
import { mapActions } from 'vuex';

export default {
  mixins: [StoreSearchResults],

  props: {
    locations: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    if (!this.searchPerformed) {
      this.setStores(this.locations);
    }
  },

  methods: {
    ...mapActions('storeSearch', ['setStores']),
  },
};
</script>

<template>
  <section v-if="isLoading">
    <div class="text-center text-white mt-12">
      <div class="loader"></div>
    </div>
  </section>

  <div class="sgphx" data-cy="store-search-result">
    <section class="md:block">
      <store-search-results-tab-map
        :stores="stores"
        :center="center"
        :zoom="zoom"
        :should-load-stores-on-bounds-changed="shouldLoadStoresOnBoundsChanged"
      />
    </section>
  </div>
</template>
